import { useEffect, useState } from 'react'
import AnimatedCounter from './AnimatedCounter'
import './css/StatsComponent.css'
import {
  getTreeRegisterCount,
  getSpecieRegisterCount,
  getFamilyRegisterCount,
  getGenderRegisterCount,
} from '../../../../../services'

const StatsComponent = () => {
  const [registersTotal, setRegistersTotal] = useState(0)
  const [specieTotal, setSpecieTotal] = useState(0)
  const [familyTotal, setFamilyTotal] = useState(0)
  const [genderTotal, setGenderTotal] = useState(0)

  useEffect(() => {
    getTreeRegisterCount()
      .then(response => setRegistersTotal(response))
      .catch(error => console.log(error))

    getSpecieRegisterCount()
      .then(response => setSpecieTotal(response))
      .catch(error => console.log(error))

    getFamilyRegisterCount()
      .then(response => setFamilyTotal(response))
      .catch(error => console.log(error))

    getGenderRegisterCount()
      .then(response => setGenderTotal(response))
      .catch(error => console.log(error))
  }, [])

  return (
    <section id="stats" className="stats section light-background">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-3 col-md-6">
            <div className="stats-item text-center w-100 h-100">
              <AnimatedCounter end={registersTotal} duration={4} />
              <p>Registros</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item text-center w-100 h-100">
              <AnimatedCounter end={specieTotal} duration={4} />
              <p>Especies</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item text-center w-100 h-100">
              <AnimatedCounter end={genderTotal} duration={4} />
              <p>Géneros</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item text-center w-100 h-100">
              <AnimatedCounter end={familyTotal} duration={4} />
              <p>Familias</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StatsComponent
